import React from "react";
import { Accordion } from "react-bootstrap";
import "./CustomAccordionGroup.css";

function CustomAccordionGroup(props) {
  return <Accordion className={props.className}>{props.children}</Accordion>;
}

export default CustomAccordionGroup;
